import React from "react";
import PropTypes from "prop-types";

import Confirmation from "settings/components/Confirmation";
import { ReducedUserRow } from "settings/components/UserRow";

import styles from "./DisableUserConfirmation.css";

export default function DisableUserConfirmation({
  user,
  onClick,
  wasClicked,
  onCancel,
}) {
  return (
    <Confirmation
      header="Are you sure you want to disable this user?"
      clickText="Yes, disable"
      onClick={onClick}
      onCancel={onCancel}
      wasClicked={wasClicked}
    >
      <p className={styles.info}>
        Disabled users will no longer be able to log in, but any articles they
        wrote will retain their byline. They can be reinstated from the Users
        page.
      </p>
      <div className={styles.userRow}>
        <ReducedUserRow user={user} />
      </div>
    </Confirmation>
  );
}

DisableUserConfirmation.propTypes = {
  user: PropTypes.shape({
    username: PropTypes.string,
    photo: PropTypes.shape({
      crops: PropTypes.shape({
        "1x1": PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
    }),
    display_name: PropTypes.string,
    job_title: PropTypes.string,
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  wasClicked: PropTypes.bool.isRequired,
};
